import { render } from "./gbzntyj.vue?vue&type=template&id=5e8ac17b&scoped=true"
import script from "./gbzntyj.vue?vue&type=script&lang=js"
export * from "./gbzntyj.vue?vue&type=script&lang=js"

import "./gbzntyj.vue?vue&type=style&index=0&id=5e8ac17b&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8ac17b"]])

export default __exports__